export enum RunState {
    Pending = 'Pending',
    NotDeployed = 'NotDeployed',
    Stopped = 'Stopped',
    Running = 'Running',
    Error = 'Error'
}
